module.exports = __webpack_public_path__ + "img/fauteuil-12.a1c71b05.jpg";